import { ButtonStyle, ModalActionTypes } from '@acorns/web-components'
import { pathOr } from 'ramda'

import AlertBadgePath from 'assets/icons/alert-badge.png'
import trackEvent from 'utils/analytics/trackEvent'
import { IErrorDetails } from 'utils/Apollo'

import { Prompt } from './prompts'

interface Props {
  showErrorModal?: (errorDetails: IErrorDetails) => void
  promptUser?: (prompt: Prompt) => void
}

interface DisplayErrorModalInput extends Props {
  errorCode: string | null
  errorCodeMap: Record<string, any>
  eventDetails?: Record<string, string>
}

export const parseGraphQLError = (error) => {
  let errorCode
  if (error.graphQLErrors) {
    // Obtain error code from GraphQL response
    errorCode = pathOr(
      null,
      ['graphQLErrors', 0, 'extensions', 'response', 'body', 'errors', 0],
      error,
    )
  } else {
    // Obtain error from REST response
    errorCode = pathOr(null, ['response', 'data', 'errors', 0], error)
  }
  return errorCode
}

export const displayErrorModal = ({
  showErrorModal,
  errorCode,
  errorCodeMap,
  eventDetails,
}: DisplayErrorModalInput) => {
  if (!errorCode) {
    return
  }

  const promptDetails = errorCodeMap[errorCode]
  if (promptDetails) {
    const { title, message, actions } = promptDetails

    showErrorModal({
      buttonStyle: ButtonStyle.column,
      image: null,
      title,
      message,
      actions,
    })
    trackEvent('Container Viewed', {
      eventData: {
        object_name: eventDetails?.objectName || 'registration.error',
        type: 'container_viewed',
        event_text: 'Container Viewed',
        screen: eventDetails?.screen || title,
        error: errorCode,
      },
    })
  } else {
    showErrorModal({
      message: 'It looks like something went wrong.',
      title: 'Oops!',
      image: AlertBadgePath,
      actions: [
        {
          type: ModalActionTypes.primary,
          label: 'OK',
        },
      ],
    })
  }
}
